
namespace TabAurous.Inventory {

    @Serenity.Decorators.registerClass()
    export class BranchOutBOMGrid extends Serenity.EntityGrid<BranchOutBOMRow, any> {
        protected getColumnsKey() { return 'Inventory.BranchOutBOM'; }
        protected getDialogType() { return BranchOutBOMDialog; }
        protected getIdProperty() { return BranchOutBOMRow.idProperty; }
        protected getInsertPermission() { return BranchOutBOMRow.insertPermission; }
        protected getLocalTextPrefix() { return BranchOutBOMRow.localTextPrefix; }
        protected getService() { return BranchOutBOMService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}